import React from "react";
import { footer, brand } from "../mock";
import { Phone } from "lucide-react";

const Footer = () => (
  <footer id="footer-section" className="relative pt-20 pb-6 overflow-hidden" style={{ backgroundImage: `url(${footer.bg})`, backgroundSize: "cover" }}>
    <div className="absolute inset-0 bg-[#2a3d5c]/92" />
    <img src={footer.flower} alt="" className="ornament left-0 top-6 w-40 opacity-60" />
    <div className="relative max-w-[1320px] mx-auto px-5 lg:px-8 text-[#ecd9c2]">
      <div className="text-center mb-10">
        <p className="eyebrow" style={{ color: "#d68767" }}>Powered by</p>
        <div className="divider-leaf my-3" />
      </div>

      <div className="grid md:grid-cols-2 gap-10">
        <div>
          <img src={footer.greatValue} alt="Great Value" className="h-16 object-contain mb-4" />
          <p className="text-[13.5px] leading-[1.9]">{footer.greatValueAbout}</p>
        </div>
        <div>
          <img src={footer.yatharth} alt="Yatharth" className="h-16 object-contain mb-4" />
          <p className="text-[13.5px] leading-[1.9]">{footer.yatharthAbout}</p>
        </div>
      </div>

      <div className="mt-10 pt-8 border-t border-white/15 grid md:grid-cols-3 gap-6 items-center">
        <div className="flex items-center gap-4">
          <img src={footer.nbcc} alt="NBCC" className="h-12 object-contain bg-white/95 rounded p-1" />
          <img src={footer.aspire} alt="Aspire" className="h-12 object-contain bg-white/95 rounded p-1" />
        </div>
        <p className="text-[12px] leading-[1.7] text-[#c9b298] md:col-span-2">Disclaimer: {footer.disclaimer}</p>
      </div>

      <div className="mt-8 pt-6 border-t border-white/15 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px]">
        <p className="text-[#c9b298]">© Copyright 2025 Eternia – Great Value Realty. All Rights Reserved.</p>
        <div className="flex items-center gap-4">
          <a href="#" className="hover:text-[#d68767] transition">Disclaimer & Privacy Policy</a>
        <div className="flex items-center gap-4 flex-wrap">
          <a href={`tel:${brand.phoneRaw}`} className="flex items-center gap-2 hover:text-[#d68767] transition"><Phone size={14} /> {brand.phone}</a>
        </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
